
export default function TestimonialsSection() {
  const testimonials = [
    {
      name: 'Sarah Johnson',
      company: 'Tech Innovations Inc.',
      role: 'CEO',
      image:
        'https://public.readdy.ai/ai/img_res/0b4e6690d61de195ffd695c301e733e9.jpg',
      rating: 5,
      text: 'Digital Domination transformed our online presence completely. Within 3 months, our organic traffic increased by 250% and our conversion rates doubled. Their team is professional, responsive, and truly understands digital marketing.',
    },
    {
      name: 'Michael Chen',
      company: 'Elite Fitness Center',
      role: 'Owner',
      image:
        'https://readdy.ai/api/search-image?query=Professional%20businessman%20portrait%20with%20friendly%20expression%20in%20modern%20office%20environment%20wearing%20business%20casual%20attire%20with%20clean%20simple%20background%20professional%20headshot%20style&width=200&height=200&seq=testimonial-002&orientation=squarish',
      rating: 5,
      text: 'Working with Digital Domination was a game-changer for our gym. Their local SEO strategies put us at the top of Google Maps, and we saw a 400% increase in new member inquiries. Highly recommend their services!',
    },
    {
      name: 'Jennifer Martinez',
      company: 'Luxury Real Estate Group',
      role: 'Marketing Director',
      image:
        'https://readdy.ai/api/search-image?query=Professional%20businesswoman%20portrait%20with%20warm%20smile%20in%20corporate%20setting%20wearing%20professional%20business%20attire%20with%20clean%20simple%20background%20professional%20headshot%20style%20natural%20lighting&width=200&height=200&seq=testimonial-003&orientation=squarish',
      rating: 5,
      text: 'The ROI we have seen from Digital Domination services is incredible. Their data-driven approach and attention to detail helped us dominate our market. Our website traffic and lead generation have never been better.',
    },
    {
      name: 'David Thompson',
      company: 'Thompson Legal Services',
      role: 'Managing Partner',
      image:
        'https://readdy.ai/api/search-image?query=Professional%20businessman%20portrait%20with%20confident%20demeanor%20in%20law%20office%20setting%20wearing%20business%20suit%20with%20clean%20simple%20background%20professional%20headshot%20style%20natural%20lighting&width=200&height=200&seq=testimonial-004&orientation=squarish',
      rating: 5,
      text: 'As a law firm, we needed a partner who understood our industry and could deliver results. Digital Domination exceeded our expectations. Our online visibility has increased dramatically, bringing in high-quality leads consistently.',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What Our Clients Say
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it. Here's what our satisfied clients have to say about
            working with Digital Domination LLC.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 border border-gray-200 hover:border-orange-500 hover:shadow-xl transition-all duration-300"
            >
              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-orange-500 text-lg"></i>
                ))}
              </div>
              <p className="text-sm text-gray-700 mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </p>
              <div className="flex items-center">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <div className="font-semibold text-gray-900 text-sm">{testimonial.name}</div>
                  <div className="text-xs text-gray-600">
                    {testimonial.role}, {testimonial.company}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-orange-600 to-orange-700 rounded-2xl p-8 md:p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">Join Our Success Stories</h3>
          <p className="text-lg mb-8 max-w-2xl mx-auto">
            Ready to transform your business and achieve remarkable results? Let's discuss how we
            can help you dominate your market.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="mailto:domination@thompsondigital.org"
              className="px-8 py-4 bg-white text-orange-600 text-base font-semibold rounded-lg hover:bg-gray-100 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap"
            >
              Get Your Free Consultation
            </a>
            <a
              href="tel:+17252756972"
              className="px-8 py-4 bg-orange-800 text-white text-base font-semibold rounded-lg hover:bg-orange-900 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap"
            >
              Call Now: (725) 275-6972
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
